import React from 'react';
import AdminLayout from '../../components/AdminLayout';

const AdminCatalogues = () => {
    return (
        <AdminLayout>
            <div style={{
                background: 'linear-gradient(135deg, rgba(201, 169, 110, 0.08) 0%, rgba(201, 169, 110, 0.03) 100%)',
                border: '1px solid rgba(201, 169, 110, 0.2)',
                borderRadius: '16px',
                padding: '60px',
                textAlign: 'center'
            }}>
                <div style={{ fontSize: '72px', marginBottom: '20px' }}>📁</div>
                <h2 style={{ fontSize: '28px', fontWeight: '300', marginBottom: '16px', color: 'var(--text-light)' }}>
                    Catalogues Management
                </h2>
                <p style={{ fontSize: '16px', color: 'rgba(245, 241, 237, 0.6)', marginBottom: '30px' }}>
                    Manage your studio catalogues and PDFs here.
                </p>
                <p style={{ fontSize: '14px', color: 'rgba(245, 241, 237, 0.5)' }}>
                    Coming Soon...
                </p>
            </div>
        </AdminLayout>
    );
};

export default AdminCatalogues;

